<template>
  <qc-container title="用户详情" show-return show-divider>
    <el-descriptions v-if="detail" :column="4" border>
      <el-descriptions-item label="用户" >
        <user-box :detail="detail"></user-box>
      </el-descriptions-item>
      <el-descriptions-item label="手机号码">
        <div style="min-width: 100px">{{detail.phone}}</div>
      </el-descriptions-item>
      <el-descriptions-item label="地区">
        <div style="min-width: 100px">
          {{(detail.province||"")+(detail.city||"")}}
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="状态">{{detail.status?"禁用":"正常"}}</el-descriptions-item>
      <el-descriptions-item label="累计消费">￥{{detail.money ||0}}</el-descriptions-item>
      <el-descriptions-item label="购买订单">{{detail.orderCount || 0}}</el-descriptions-item>
      <el-descriptions-item label="最近登录时间">{{detail.lastLoginTime}}</el-descriptions-item>
      <el-descriptions-item label="注册时间">{{detail.createTime}}</el-descriptions-item>
    </el-descriptions>
  </qc-container>

  <qc-container class="mt20" :tab-list="['商城订单','租售订单','所属商户','亲友信息']" :active-index="activeIndex" @changeTab="changeTab">

  </qc-container>
</template>

<script>

import QcContainer from "@/components/el/layout/qc-container.vue";
import UserBox from "@view/components/user-box.vue";

export default {
  name: "detail",
  components: {UserBox, QcContainer},
  data() {
    return {
      detail:null,
      activeIndex:0,
    }
  },
  mixins: [tableBase],
  methods: {
    changeTab(index){
      this.activeIndex = index;
    }
  },
  mounted() {
    this.simplePost("/api/mgr/user/expand/getDetail",{id:this.$route.query.id},(res)=>{
      this.detail = res.data;
    });
  }
}
</script>


<style lang="less" scoped>
</style>
